import styled from 'styled-components';
import { Collapse } from 'antd';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  secondaryFont, primaryFont, primaryHeadingColor, wLight, maxWidth, retina, maxMobile, maxTablet,
} from 'Utils/utilsStyle';
import PeopleIcon from '../../svgIcons/PeopleIcon';

const StyleWrapper = styled.div`
  padding-bottom: 70px;
  .fancy-box {
    border-radius: 10px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
    background: rgb(255, 255, 255);
    padding: 23px;
    margin-top: 50px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 17px 16px 16px 16px;
    }
  
    h1 {
      font-family: ${secondaryFont};
      color: ${primaryHeadingColor};
      font-size: 22px;
      margin-bottom: 0;
      margin-left: 10px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 19px;
      }
    }
    p {
      font-family: ${primaryFont};
      color: #5e7079;
    }
    input {
      font-size: 16px;
      padding: 7px 12px;
    }
    label {
      font-size: 12px;
    }
    .companiesSection {
      margin-top: 20px;
    }
    h4.recommended-name{
      color:${primaryHeadingColor};
      font-weight:${wLight};
      font-family:${secondaryFont};
      margin-bottom:0;
      font-size:22px;
      line-height: 38px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 18px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 14px;
        line-height: 19px;
      }
    }
    .ant-collapse-header, .ant-collapse-content-box {
      padding: 0px !important;
      align-items: center;
    }
    .ant-collapse-item {
      .ant-collapse-arrow {
        display: none !important;
      }
      .heading-collapse-c {
        .heading-icon {
          display: none;
        }
      }
      &.ant-collapse-item-active {
        .user-images {
          display: none;
        }
        .heading-collapse-c {
          .heading-icon {
            display: block;
            margin-right: 15px;
            margin-top: 5px;
          }
        }
        .ant-collapse-extra {
          display: none;
        }
      }
    }
    .user-images{
    position: relative;
    margin-right:13px;
    z-index:0;
    > div{
        padding:2px !important;
        &:nth-child(1){
          z-index:5;
        }
        &:nth-child(2){
          z-index:4;
          margin-left: -10px;
        }
        &:nth-child(3){
          z-index:3;
          margin-left: -10px;
        }
        &:nth-child(4){
          z-index:2;
          margin-left: -10px;
        }
        &:nth-child(5){
          z-index:1;
          margin-left: -10px;
        }
    }
  }
  }
`;

const RecommendedCompaniesSectionSkeleton = function RecommendedCompaniesSectionSkeleton() {
  const { Panel } = Collapse;

  return (
    <StyleWrapper>
      <div className="fancy-box">
        <Collapse ghost>
          <Panel
            header={(
              <div className="d-flex heading-collapse-c">
                <div className="heading-icon">
                  <PeopleIcon />
                </div>
                <h4
                  className="recommended-name d-flex align-items-center"
                >
                  <SkeletonCustom width="500px" smWidth="310px" height="20px" margin="0px" />
                </h4>
              </div>
            )}
            key="1"
          />
        </Collapse>
      </div>
    </StyleWrapper>
  );
};

export default RecommendedCompaniesSectionSkeleton;
